import { Component, Prop, h } from '@stencil/core';

import { onStateFieldAnswered } from '../../../actions/actions.answers';
import { VehicleColorOption } from '../../../interfaces/interface.vehicle';
import { VehicleConfigState } from '../../../store/store.vehicle-config';

@Component({
  tag: 'vehicle-color',
  styleUrl: 'vehicle-color.css',
})
export class VehicleColor {
  @Prop() vehicleConfig: VehicleConfigState;
  @Prop() vehicleColorIdAnswer: number;

  isSelectedColor(color: VehicleColorOption) {
    const { optionId } = color;
    return this.vehicleColorIdAnswer === optionId;
  }

  setAsSelectedColor(color: VehicleColorOption) {
    const { displayName, optionId } = color;
    onStateFieldAnswered('vehicle', 'colorId', optionId);
    onStateFieldAnswered('vehicle', 'color', displayName);
  }

  renderColorSwatches() {
    return this.vehicleConfig.availColors
      .sort((a, b) => (a.displayName > b.displayName ? 1 : -1))
      .map((color) => (
        <li class="text-center">
          <color-swatch-button
            label={color.displayName}
            colorHex={color.colorHex}
            onClick={() => {
              this.setAsSelectedColor(color);
            }}
            isActive={this.isSelectedColor(color)}
          />
        </li>
      ));
  }

  render() {
    return (
      <box-shadow>
        <h2 class="ico-components-heading-large mb-2">What Color Is Your Vehicle?</h2>
        <div class="mb-4 text-sm">Colors may not exactly match your vehicle.</div>
        <ul class="list-none flex flex-wrap w-full p-0 xs:gap-2 md:gap-4">{this.renderColorSwatches()}</ul>
      </box-shadow>
    );
  }
}
